import React from "react";

const DemoSection = () => {
  return (
    <div className="w-full bg-grey-custom mx-auto md:mt-16 px-4 md:px-8">
      <div className="container mx-auto">
        <h1 className="section-heading text-center mb-8">
          Sample PMIstandards+ for Yourself
        </h1>
        <div className="flex items-center justify-center mb-16">
          <img
            className="md:w-3/4"
            src="images/standards-plus-demo.gif"
            alt="Standards Plus Demo"
          />
        </div>
      </div>
    </div>
  );
};

export default DemoSection;
